<template>
  <el-card shadow="never" v-loading="loading">
    <el-form label-width="250px">
        <el-form-item label="Late Fee in percentage">
          <el-input-number
            v-model="lateFee"
            :precision="2"
            :max="25"
            :min="0"
            @change="enableSaveButton"
          >
          </el-input-number>
          <el-button :disabled="!editLateFee" @click="saveLateFee">
            Save
          </el-button>
        </el-form-item>
        <el-form-item label="Chronic Late Fee in percentage">
          <el-input-number
            v-model="chronicLateFee"
            :precision="2"
            :max="25"
            :min="0"
            @change="enableChronicSaveButton"
          >
          </el-input-number>
          <el-button :disabled="!editChronicLateFee" @click="saveLateFee">
            Save
          </el-button>
        </el-form-item>
      </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';
import { getFacility } from '../utils/commonApi';

export default {
  name: 'FacilityLateFee',
  props: { facility: { type: String, required: true } },
  data() {
    return {
      loading: false,
      lateFee: 0,
      chronicLateFee: 0,
      editLateFee: false,
      editChronicLateFee: false,
    };
  },
  watch: {
    async facility() {
      this.getData();
    }
  },
  async mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const response = await getFacility(this.facility, { token: this.$keycloak.token });
      this.lateFee = response.lateFeePrice ? response.lateFeePrice : 0;
      this.chronicLateFee = response.chronicLateFeePrice ? response.chronicLateFeePrice : 0;
      this.loading = false;
    },
    enableSaveButton() {
      this.editLateFee = true;
    },
    enableChronicSaveButton() {
      this.editChronicLateFee = true;
    },
    async saveLateFee() {
      this.loading = true;
      const result = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        ...(this.editLateFee ? { lateFeePrice: this.lateFee } : {}),
        ...(this.editChronicLateFee ? { chronicLateFeePrice: this.chronicLateFee } : {}),
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.$root.$data.setFacilityDataAction(result.data);
      this.lateFee = result.data.lateFeePrice ? result.data.lateFeePrice : 0;
      this.chronicLateFee = result.data.chronicLateFeePrice ? result.data.chronicLateFeePrice : 0;
      this.editLateFee = false;
      this.editChronicLateFee = false;
      this.loading = false;
      this.$message.success({
        title: 'Success',
        message: 'Successfully updated Late Fee.',
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilityLateFee.vue